/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function PDF({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M10.825 6.5a.5.5 0 0 0-.5.5v4.5a.5.5 0 1 0 1 0V9.75h.906a.5.5 0 1 0 0-1h-.906V7.5H12.7a.5.5 0 0 0 0-1h-1.875Z" /><path fill="currentColor" fillRule="evenodd" d="M3.2 7a.5.5 0 0 1 .5-.5h.969a1.5 1.5 0 0 1 1.5 1.5v.25a1.5 1.5 0 0 1-1.5 1.5H4.2v1.75a.5.5 0 1 1-1 0V7Zm1 1.75h.469a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H4.2v1.25ZM7.1 6.5a.5.5 0 0 0-.5.5v4.5a.5.5 0 0 0 .5.5h.656a2 2 0 0 0 2-2V8.5a2 2 0 0 0-2-2H7.1Zm.656 4.5H7.6V7.5h.156a1 1 0 0 1 1 1V10a1 1 0 0 1-1 1Z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M4 .4A2.6 2.6 0 0 0 1.4 3v10A2.6 2.6 0 0 0 4 15.6h8a2.6 2.6 0 0 0 2.6-2.6V5.828a2.6 2.6 0 0 0-.761-1.838L11.01 1.162A2.6 2.6 0 0 0 9.172.4H4ZM2.6 3A1.4 1.4 0 0 1 4 1.6h5.172a1.4 1.4 0 0 1 .99.41L12.99 4.84a1.4 1.4 0 0 1 .41.99V13a1.4 1.4 0 0 1-1.4 1.4H4A1.4 1.4 0 0 1 2.6 13V3Z" clipRule="evenodd" /></svg>;
}
;